const PREFIX = 'bravissimo/messages/';
export const ADD = `${PREFIX}ADD`;
export const DISMISS = `${PREFIX}DISMISS`;
export const CLEAR_ALL = `${PREFIX}CLEAR_ALL`;
